var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container power-box" },
    [
      _c(
        "div",
        { staticClass: "common-header" },
        [
          _c("common-header", {
            attrs: {
              headerList: [
                { label: "系统管理", url: "" },
                { label: "系统权限", url: "" }
              ]
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "power-top" },
        [
          _c("search-form", {
            attrs: { formData: _vm.searchFormData, btnType: _vm.btnType },
            on: {
              searchForm: _vm.searchForm,
              addTable: _vm.addTable,
              resetForm: _vm.resetForm
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "power-table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
                height: _vm.tableheight,
                border: ""
              },
              on: {
                "header-dragend": _vm.headerdragend,
                "selection-change": _vm.handleSelectionChange
              }
            },
            [
              _c("template", { slot: "empty" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c("no-data", {
                      attrs: { height: "400px", width: "400px" }
                    })
                  ],
                  1
                )
              ]),
              _c("el-table-column", {
                attrs: { type: "selection", fixed: "", width: "50" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "systemName",
                  label: "系统名称",
                  "min-width": "80",
                  width: "200"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.systemName)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.systemName))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "permissionId",
                  label: "权限编号",
                  "min-width": "80",
                  width: "200"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.permissionId)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.permissionId))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "permissionName",
                  label: "权限名称",
                  "min-width": "80",
                  width: "250"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.permissionName)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.permissionName))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "permissionDesc",
                  "min-width": "80",
                  label: "权限描述"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.permissionDesc)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.permissionDesc))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "权限状态",
                  "min-width": "80",
                  width: "200",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", {
                          class:
                            scope.row.permissionStatus == "VALID"
                              ? "statusicon"
                              : "unstatusicon"
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "statustitle" }, [
                          _vm._v(
                            _vm._s(
                              scope.row.permissionStatus == "VALID"
                                ? "有效"
                                : "失效"
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "60", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            ref: "power-" + scope.row.id,
                            attrs: {
                              placement: "right",
                              width: "190",
                              trigger: "click",
                              "popper-class": "table-popper"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "op-tips" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "op-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.editRoleDialog(scope, true)
                                      }
                                    }
                                  },
                                  [
                                    _c("operate-edit-icon", {
                                      staticClass: "svgOperateIcon"
                                    }),
                                    _vm._v(" 编辑")
                                  ],
                                  1
                                ),
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: { title: "确定删除此条权限吗？" },
                                    on: {
                                      onConfirm: function($event) {
                                        return _vm.confirmdel(scope, true)
                                      },
                                      onCancel: function($event) {
                                        return _vm.confirmdel(scope, false)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "op-item",
                                        attrs: { slot: "reference" },
                                        slot: "reference"
                                      },
                                      [
                                        _c("delIcon", {
                                          staticClass: "svgOperateIcon"
                                        }),
                                        _vm._v(" 删除")
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "op-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.seePowerDialog(scope)
                                      }
                                    }
                                  },
                                  [
                                    _c("operate-power-icon", {
                                      staticClass: "svgOperateIcon"
                                    }),
                                    _vm._v(" 权限资源对应关系维护")
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c("operate", {
                              staticClass: "operate-icon",
                              attrs: { slot: "reference" },
                              slot: "reference"
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "power-footer" },
            [
              _c("input", {
                staticClass: "btn btn-red btn-del",
                attrs: { type: "button", value: "删除" },
                on: { click: _vm.showdeldialog }
              }),
              _vm.pageshow
                ? _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.totalrecord,
                      "hide-on-single-page": false,
                      "page-sizes": [10, 20, 50, 100, 1000, 2000],
                      "page-size": 10,
                      "current-page": _vm.filtratedata.pageNum
                    },
                    on: {
                      "update:currentPage": function($event) {
                        return _vm.$set(_vm.filtratedata, "pageNum", $event)
                      },
                      "update:current-page": function($event) {
                        return _vm.$set(_vm.filtratedata, "pageNum", $event)
                      },
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "power-menage-dialog",
          attrs: {
            title: "权限资源关系维护",
            visible: _vm.showPowerMaintain,
            width: "1200"
          },
          on: {
            "update:visible": function($event) {
              _vm.showPowerMaintain = $event
            }
          }
        },
        [
          _c("power-maintain", {
            attrs: {
              mobilemenulist: _vm.mobilemenulist,
              menuresourceslist: _vm.menulist,
              portresourceslist: _vm.portlist,
              pemiss: _vm.selectpermission
            },
            on: { powerMaintainSubmit: _vm.powerMaintainSubmit }
          })
        ],
        1
      ),
      _vm.showRoleEdit
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "dialog_footer_btn",
              attrs: {
                width: "560px",
                title: _vm.ifAddEdit ? "编辑权限" : "新增权限",
                visible: _vm.showRoleEdit
              },
              on: {
                "update:visible": function($event) {
                  _vm.showRoleEdit = $event
                }
              }
            },
            [
              _c("power-add", {
                ref: "poweradddefult",
                attrs: {
                  ifAddEdit: _vm.ifAddEdit,
                  AddformData: _vm.searchFormData,
                  systemdata: _vm.selectsystem
                },
                on: { powerAddSubmit: _vm.powerAddSubmit }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            width: "382px",
            title: "删除权限",
            visible: _vm.ifShowDelDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.ifShowDelDialog = $event
            }
          }
        },
        [
          _c("del-dialog", {
            attrs: {
              tips1: "确定要删除所选权限吗？",
              tips2: "删除权限后无法恢复，是否要删除权限"
            },
            on: {
              cancle: function($event) {
                _vm.ifShowDelDialog = false
              },
              commit: _vm.delpermission
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }